import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Carousel } from 'primeng/carousel';

import { WigAwardsSummary } from '../wig-awards-summary.model';

@Component({
  selector: 'app-wig-awards-months',
  templateUrl: './wig-awards-months.component.html',
  styleUrls: ['./wig-awards-months.component.css'],
})
export class WigAwardsMonthsComponent implements OnInit, AfterViewInit {
  @Input() awardsSummary: WigAwardsSummary;
  @ViewChild('monthlyStatsCarousel') monthlyStatsCarousel: Carousel;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.monthlyStatsCarousel.onDotClick(this, this.awardsSummary?.earnedPoints.length - 1);
  }
}
